"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pathToRegexp = require("path-to-regexp");
var PathTemplate = /** @class */ (function () {
    function PathTemplate(text, opts) {
        this._keys = [];
        this._text = text;
        this._re = pathToRegexp(text, this._keys, opts);
    }
    Object.defineProperty(PathTemplate.prototype, "text", {
        get: function () {
            return this._text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PathTemplate.prototype, "paramNames", {
        get: function () {
            return this._keys.map(function (k) { return k.name; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PathTemplate.prototype, "paramCount", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    PathTemplate.prototype.test = function (path) {
        var r = {
            match: this._re.test(path)
        };
        if (r.match) {
            var params_1 = {};
            var er_1 = this._re.exec(path);
            this._keys.forEach(function (key, idx) {
                params_1[key.name] = decodeURIComponent(er_1[idx + 1]);
            });
            r.params = params_1;
        }
        return r;
    };
    PathTemplate.prototype.toPath = function (params) {
        if (!this._pf) {
            this._pf = pathToRegexp.compile(this._text);
        }
        return this._pf(params);
    };
    PathTemplate.prototype.toString = function () {
        return this._text;
    };
    return PathTemplate;
}());
exports.PathTemplate = PathTemplate;
var matches = function (value, pattern) {
    var template = new PathTemplate(pattern);
    var mr = template.test(value);
    return mr.match;
};
exports.matches = matches;
